// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"e2516072","190":"bdc4a09f","392":"cd937b9f","971":"c8195b86"}[chunkId] + ".chunk.js";
};